import * as React from 'react';
import './nav-button.scss';
import { ReactComponent as RightArrow } from '../../assets/icons/right-arrow.svg';
import { ReactComponent as LeftArrow } from '../../assets/icons/left-arrow.svg';

interface Props {
    action?: Function;
    direction?: string;
}

const NavButton: React.FunctionComponent<Props> = ({ action, direction }) => {
    const buttonClick = () => {
        action && action(true);
    };

    return (
        <div>
            <div className="nav-button" onClick={buttonClick}>
                <div className="nav-button__arrow">{direction === 'RIGHT' ? <RightArrow /> : <LeftArrow />}</div>
            </div>
        </div>
    );
};
export default NavButton;
